import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../core/shared/helper/widget-function-call-back-create";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {ObjectIdentifierData} from "../../../../../../../core/shared/basic/object-identifier-data";
import {
    MvsObjectNavigationService
} from "../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {
    MvsObjectNavigationEntry
} from "../../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";


@Component({
    selector: 'ei-structure-ql-query-params-component',
    templateUrl: 'ei-structure-ql-query-params.component.html',
    standalone: false
})
export class EiStructureQlQueryParamsComponent implements OnInit, OnChanges {

    @Input() structureId: number;
    @Input() importTypeId: number;

    initialized: boolean;
    widget: WidgetData;

    private builtForId: number;

    constructor(protected navigationService: MvsObjectNavigationService) {
    }

    ngOnInit() {
        this.initComponent();
        this.initialized = true;
    }

    initComponent() {
        if (!this.structureId) {
            return;
        }
        // Skip rebuild on every change-detection pass; only rebuild when the parent id actually changes.
        if (this.widget && this.builtForId === this.structureId) {
            return;
        }

        this.widget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'ei.structure.qlQueryParams.widget',
            'QL-Abfrageparameter',
            'ei.EiStructureQlQueryParam',
            [FilterCriteria.create('e.structureId', FilterCriteria.cOperatorEqual, this.structureId)],
            []
        );

        // FK defaulting on create (CONFIG-012)
        const fields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'structureDtoId', fieldValue: this.structureId}
        ];
        if (this.importTypeId) {
            fields.push({fieldName: 'importTypeDtoId', fieldValue: this.importTypeId});
        }
        this.widget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
        this.builtForId = this.structureId;
    }

    onItemSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        if (!event?.objectId) {
            return;
        }
        const entry = MvsObjectNavigationEntry.createNavigationEntry(
            'ei.EiStructureQlQueryParam',
            event.objectId,
            'object', '', '', '',
            MvsObjectNavigationActionEnum.edit
        );
        this.navigationService.navigateTo(entry, 'main');
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
        this.initComponent();
    }

}
